import React from 'react';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { isObjectPathDefined } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import NoDataComponent from '../common/noDataComponent';
import ReportSection from '../common/reportSection';
import Message from '../common/message';
import TopPanel from '../layoutItems/topPanel';

import "./report.scss";

class WarningsReportComponent extends React.Component {
    render() {
        const agentLanguage = this.props.user.authentication.profile.agentLanguage;
        return (
            <div className="report-container" style={{ fontSize: '.875em' }}>
                <TopPanel {...{ ...this.props.componentProps, tinted: localStorage.locales_tint === 'header' }} />
                <div className={classnames("header unlimited", {"tinted": localStorage.locales_tint === 'header'})}>
                    <Translate id="Report.Warnings.WarningsAndSupplementaryInfo" />
                </div>
                <div className="report-sections-wrapper">
                    <div className="no-name">
                        {this.chceckSectionError() &&
                            <Message type='warning' message={<Translate id={"UnhappyUser.ReportSectionsError"} options={{ renderInnerHtml: true }} />} />}
                        {this.renderContent()}
                        <div className="disclaimer-wrapper">
                            <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                            <hr className="report-component-hr" style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                            <div className="disclaimer-gray">
                                <Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.props.requestGetReportSettings(this.props.match.params.id, 'WarningsReport');
    }

    componentDidUpdate() {
        if (this.props.requestedReload === true) {
            this.props.requestGetReportSettings(this.props.match.params.id, 'WarningsReport');
        }
    }

    componentWillUnmount() {
        this.props.onLeavingReport();
        this.props.toggleSectionEditMode(false);
        if (this.props.sections) {
            this.props.restoreConfig();
        }
    }

    renderContent = () => {
        if (isNullOrUndefined(this.props.sections))
            return <NoDataComponent />;

        return (
            <div className="report-unlimited-wrapper">
                {this.props.sections.map(s => <ReportSection key={s.id + '-' + s.orderId} sectionId={s.id} />)}
            </div>
        );
    }

    chceckSectionError() {
        var error = false;
        if (isObjectPathDefined(this.props, 'report.sections')) {
            this.props.report.sections.forEach(section => {
                if (isObjectPathDefined(section, 'error') && section.error !== null)
                    error = true;
            });
        }
        return error;
    }
}

export default withRouter(connect(
    state => ({ ...state.report, user: state.userContext }),
    dispatch => bindActionCreators(reportActions, dispatch)
)(WarningsReportComponent));
